module.exports = __webpack_public_path__ + "img/waiting-for-approval.09f744a6.svg";